module.exports = __webpack_public_path__ + "static/media/epark-logo.14a2c128.svg";